// wrap plugin -> https://swagger.io/docs/open-source-tools/swagger-ui/customization/plugin-api/
import React from "react"
import {unified} from 'unified';
import remarkParse from 'remark-parse';
import remarkRehype from 'remark-rehype';
import rehypeStringify from 'rehype-stringify';
import DOMPurify from 'dompurify';

export default class ApiOperationTag extends React.Component {
    render() {
        // get the wrapped component
        const Wrapped = this.props.operationTag;

        // for now just return that component without modification
        const rendered = <Wrapped {...this.props.operationTagProps}/>;

        // get details about element
        const {
            tag,
            tagObj
        } = this.props.operationTagProps;

        // prepare/condition string and remove leading spaces
        let tagDescription = tagObj.getIn(["tagDetails", "description"], null);
        if (null !== tagDescription) {
            tagDescription = tagDescription.split('\n').map(line => line.trimStart()).join('\n');
        }

        // generate the markdown, using the components from `react-markdown` directly causes
        // errors regarding unreadable href properties when links are in the body.q
        const markdown = unified()
            .use(remarkParse)
            .use(remarkRehype)
            .use(rehypeStringify)
            .processSync(tagDescription);

        // using dompurify allows us to set the html as safely as possible
        const markdownPurified = DOMPurify.sanitize(markdown.value);

        // render only the children
        return <div>
            <div className={['api-flex-container']}>
                <div id={"tokens"} className={['api-flex-full']}><h2>{tag}</h2></div>
                <div className={['api-flex-text-body']} dangerouslySetInnerHTML={{__html: markdownPurified}}>
                </div>
            </div>
            <div>
                {rendered.props.children}
            </div>
        </div>
    }

}